<unity-page-container
  contentHeader="Manage Form Templates"
  [contentHeaderSecondary]="$contentHeaderSecondary()"
  [isLoading]="$isAgreementLoading()">
  <ng-container page-return> <unity-action-shared [action]="$returnToAgreementAction()" /></ng-container>

  <ng-container notifications />

  <ng-container actions>
    <unity-action-shared [action]="$createFormScheduleAction()" />
  </ng-container>

  <unity-grid-agreement-form-shared [agreementId]="$agreementId()" />
</unity-page-container>
